import type { RoutineExecutionStatus } from '@yawi/types';
import React from 'react';

const STATUS_STYLES: Record<RoutineExecutionStatus, string> = {
  running: 'bg-blue-100 text-blue-700',
  success: 'bg-emerald-100 text-emerald-700',
  failed: 'bg-red-100 text-red-700',
  cancelled: 'bg-slate-100 text-slate-600',
  skipped: 'bg-slate-100 text-slate-500',
};

const STATUS_LABELS: Record<RoutineExecutionStatus, string> = {
  running: 'Ejecutando',
  success: 'Exitosa',
  failed: 'Fallida',
  cancelled: 'Cancelada',
  skipped: 'Omitida',
};

interface Props {
  status: RoutineExecutionStatus;
}

export const ExecutionStatusBadge: React.FC<Props> = ({ status }) => (
  <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${STATUS_STYLES[status]}`}>
    {STATUS_LABELS[status]}
  </span>
);
